import "../sass/index.scss"
import Glide from "@glidejs/glide"

// Testimonials FrontPage

if (document.querySelector("#testimonials")) {
    const config = {
        type: "carousel",
        perView: 2,
        focusAt: 0,
        gap: 32,
        autoplay: 3000,
        hoverpause: true,
        breakpoints: {
            768: {
                perView: 2,
            },
            576: {
                perView: 1,
            },
        },
    }
    new Glide("#testimonials", config).mount()
}
if (document.querySelector("#kinderSpecial")) {
    const config = {
        type: "carousel",
        perView: 3,
        focusAt: "center",
        gap: 32,
        autoplay: 3000,
        hoverpause: true,
        breakpoints: {
            768: {
                perView: 2,
            },
            576: {
                perView: 1,
            },
        },
    }
    new Glide("#kinderSpecial", config).mount()
}

// Gallery

const gallery = document.getElementById("lightgallery")
if (gallery) {
    lightGallery(gallery)
}

// Mobile Menu

const menuBtn = document.querySelector("#menuBtn")
if (menuBtn) {
    const mobileMenu = document.querySelector("#mobileMenu")
    menuBtn.addEventListener("click", () => {
        mobileMenu.classList.remove("translate-x-full")
        const closeMenuBtn = mobileMenu.querySelector("#closeMenuBtn")
        closeMenuBtn.addEventListener("click", () => {
            mobileMenu.classList.add("translate-x-full")
        })
        const collapse = mobileMenu.querySelector("#collapse")
        const placowki = mobileMenu.querySelector("#placowki")
        collapse.addEventListener("click", () => {
            placowki.classList.remove("h-0")
        })
    })
}
